import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./Components/Navbar";

import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Services from "./pages/Services/Services";
import Contact from "./pages/Contact/Contact";
import FAQ from "./pages/FAQ/FAQ";

import "./App.css";
import Footer from "./Components/Footer";
import Whatsapp from "./Components/Whatsapp";

function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
      </Routes>
      <Whatsapp/>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;